import { Phone, Mail, MapPin } from 'lucide-react';
import { SITE_CONFIG, IMAGES } from '../lib/constants';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="footer-section" className="bg-[#0A1628] pt-20 pb-8">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-3 gap-12 md:gap-16 pb-12 border-b border-white/10">
          <div>
            <img src={IMAGES.logoAlt} alt="HDH Pools & Spas" className="h-14 rounded-lg mb-6 brightness-150" />
            <p className="text-sm text-white/40 font-body leading-relaxed max-w-xs">
              Modern pool construction with organized operations and
              transparent communication. Serving Southern Utah.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-lg font-600 text-white italic mb-6">
              Contact
            </h4>
            <div className="space-y-4">
              <a
                href={`tel:${SITE_CONFIG.phone}`}
                data-testid="footer-phone-link"
                className="flex items-center gap-3 text-sm text-white/50 hover:text-amber-400 transition-colors font-body"
              >
                <Phone className="h-4 w-4 flex-shrink-0" />
                {SITE_CONFIG.phone}
              </a>
              <a
                href={`mailto:${SITE_CONFIG.email}`}
                data-testid="footer-email-link"
                className="flex items-center gap-3 text-sm text-white/50 hover:text-amber-400 transition-colors font-body"
              >
                <Mail className="h-4 w-4 flex-shrink-0" />
                {SITE_CONFIG.email}
              </a>
              <div className="flex items-center gap-3 text-sm text-white/50 font-body">
                <MapPin className="h-4 w-4 flex-shrink-0" />
                {SITE_CONFIG.location}
              </div>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-lg font-600 text-white italic mb-6">
              Quick Links
            </h4>
            <div className="space-y-3">
              {[
                { label: 'Our Process', href: '#process' },
                { label: 'Gallery', href: '#gallery' },
                { label: 'Request a Quote', href: '#quote' },
                { label: 'Client Login', href: SITE_CONFIG.portalUrl, testId: 'footer-client-login-link' },
              ].map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  data-testid={link.testId}
                  className="block text-sm text-white/50 hover:text-amber-400 transition-colors font-body"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-white/30 font-body">
            &copy; {currentYear} {SITE_CONFIG.company}. All rights reserved.
          </p>
          <p className="text-xs text-white/30 font-body">
            Powered by Pool Ops Hub
          </p>
        </div>
      </div>
    </footer>
  );
};
